import { defineMessages } from 'react-intl-next';

export const messages: {
	descriptionFieldLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	descriptionPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	linkFieldLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	recommendedFieldLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titleFieldLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	titlePlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	linkFieldLabel: {
		id: 'company-hub.carousel-extension.config-panel.link.field.label',
		defaultMessage: 'Link',
		description: 'Visible label for link field in the carousel config panel',
	},
	titleFieldLabel: {
		id: 'company-hub.carousel-extension.title.field.label',
		defaultMessage: 'Title',
		description: 'Visible label for title field in the carousel config panel',
	},
	recommendedFieldLabel: {
		id: 'company-hub.carousel-extension.recommended.field.label',
		defaultMessage: '(Recommended)',
		description: 'Visible `recommended` label for the title field in the carousel config panel',
	},
	descriptionFieldLabel: {
		id: 'company-hub.carousel-extension.description.field.label',
		defaultMessage: 'Description',
		description: 'Visible label for description field in the carousel config panel',
	},
	titlePlaceholder: {
		id: 'company-hub.carousel-extension.title.placeholder',
		defaultMessage: 'Give your frame a title',
		description: 'Placeholder for title field in the carousel config panel',
	},
	descriptionPlaceholder: {
		id: 'company-hub.carousel-extension.description.placeholder',
		defaultMessage: 'Customize this frame to create a rotating carousel.',
		description: 'Placeholder for description field in the carousel config panel',
	},
});
